import { createStorefrontApiClient } from '@shopify/storefront-api-client'

export const storefrontClient = createStorefrontApiClient({
  storeDomain: 'https://thisisneeded.com',
  apiVersion: '2024-04',
  publicAccessToken: 'b3cb9819ad7873a59d0706b42ca006d5',
})

export async function updateDiscountCodes(client, token, discountCodes = []) {
  const query = `
    mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
        cart {
          discountCodes{
            applicable
            code
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `
  const variables = {
    cartId: `gid://shopify/Cart/${token}`,
    discountCodes: discountCodes,
  }

  return await client.request(query, { variables })
}

export async function getWholesalerMetaobjectById(client, id) {
  const query = `
    query {
    metaobject(handle: { handle: "${id}", type: "wholesaler" }) {
      impact_id: field(key: "impact_id") {
        value
      }
      practitioner: field(key: "practitioner") {
        reference {
          ... on Metaobject {
            name: field(key: "name") {
              value
            }
            image: field(key: "image") {
              reference {
                ... on MediaImage {
                  image {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
  return await client.request(query)
}
